<template>
  <v-dialog
    width="500"
    :model-value="dialog"
    transition="dialog-bottom-transition"
  >
    <v-card
      flat
      width="500"
      :style="{
        borderBottom: '3px solid #272727',
        borderLeft: '1px solid #272727',
        borderTop: '1px solid #272727',
        borderRight: '3px solid #272727',
      }"
      v-if="dialog"
    >
      <v-sheet
        class="d-flex justify-center align-center py-2"
        color="accent"
        style="font-size: 10pt; font-weight: 600"
      >
        Edit template
      </v-sheet>
      <v-divider class="primary"></v-divider>
      <div class="pa-6">
        <div v-for="(t, index) in template.blocks" :key="index">
          <v-text-field v-model="t.text"></v-text-field>
        </div>
        <v-btn @click="save">save</v-btn>
      </div>
      <v-divider class="primary"></v-divider>
      <Preview :template="template" />
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import * as htmlToImage from "html-to-image";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import Preview from "@/components/templates/PreviewComp.vue";

export default {
  props: ["dialog", "template", "post_uid"],
  components: {
    Preview,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
    }),
  },
  data() {
    return {};
  },
  methods: {
    async save() {
      console.log("saving image");
      let template = await htmlToImage.toPng(
        document.getElementById("my-node"),
        { quality: 1 }
      );

      const storeTemplate = httpsCallable(functions, "storeTemplate");
      const res = await storeTemplate({
        base64Image: template,
        uid: null,
      });

      this.$emit("result", res.data.thumbnail);
    },
  },
};
</script>

<style lang="scss" scoped>
.template {
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>
